import "./utils/install-error-reporting";
import React, { useEffect } from "react";
import ReactDOM from "react-dom/client";
import "./amplifyConfig";
import "./index.css";
import App from "./App";
import { markAppBooted } from "./utils/flow-telemetry";

// Commits after App's first render succeeds. Effects run in tree order, so if
// App throws while rendering this never commits and the crash is reported as
// APP_LOAD_FAILED rather than JS_CRASH.
function BootMarker(): null {
  useEffect(markAppBooted, []);
  return null;
}

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);

root.render(
  <React.StrictMode>
    <App />
    <BootMarker />
  </React.StrictMode>
);
// SW registration is owned by useServiceWorker (mounted via UpdateBanner in App).
// A second call here would register without an update callback, silently dropping
// the update notification before the hook mounts.
